import React, { useEffect, useRef, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./header/header";
import SideMenu from "./sideMenu/sideMenu.jsx";
import Footer from "./footer/footer";

const LayoutComponent = ({ refresh }) => {
  const [isLoading, setIsLoading] = useState(false);
  const scrollContainerRef = useRef(null);
  const location = useLocation();

  const handleReload = (reload) => {
    setIsLoading(reload);
  };

  useEffect(() => {
    scrollContainerRef.current?.scrollTo({ top: 0, left: 0 });
  }, [location.pathname, location.search]);

  return (
    <>
      {isLoading ? (
        <div></div>
      ) : (
        <div className="main-dialog-box">
          <div className="main-dialog-first">
            <Header refreshHeader={refresh} reload={handleReload}></Header>
          </div>
          <div className="main-dialog-second" ref={scrollContainerRef}>
            <div className="main-dialog-layout">
              <SideMenu></SideMenu>
              <div className="center-layout">
                <div className="layout-screen">
                  <Outlet></Outlet>
                </div>
                <Footer></Footer>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LayoutComponent;
